import React, { useState, useEffect } from 'react'
import AuthLayout from '../../../../layout/AuthLayout'
import { useDispatch } from 'react-redux'
import { updateRoute } from '../../../../store/dataRoute'
import { getAllOrderList } from '../../../../services/orders'
import classes from '../../../../assets/module-css/AdminLayout.module.css'
import { Box, Flex, Button, Text, Group, Pagination, Select, Modal, Badge } from '@mantine/core'
import { IconPlus } from '@tabler/icons-react'
import LoadingData from '../../../../component/ui/LoadingData'
import OrderList from '../../../../component/pages/Orders/OrderList'
import NoData from '../../../../component/ui/NoData'
import { shipmentMethod } from '../../../../helper/master-unit'
import FormFilterOrders from '../../../../component/pages/Orders/FormFilterOrders'
import dayjs from 'dayjs'
import { useNavigate } from 'react-router-dom'

const defaultParams = {
  'page[num]': 1,
  'page[limit]': 10,
  sort: '-order_date',
  include: 'statuses,platform,packages,sales,status_histories',
  'fields[-order]': 'details',
  'fields[order]': 'id,order_infos,order_code,platform_id,currency_order,order_date,user_id,ordered_by_user_id,origin,shipment_from,shipment_to,grand_total,tracking_code,order_category,order_type,destination,total_logistic_charges,total_custom_charges,shipment_method,updated_at,been_paid,created_at,marking_code,terms,terms_note,load_type,user,agent,invoice_url',
}

const defaultPaymentStatus = [
  {
    label: 'Unpaid Balance',
    value: '1'
  },
  {
    label: 'Unpaid Goods',
    value: '2'
  },
  {
    label: 'Paid Goods Only',
    value: '3'
  },
  {
    label: 'Unpaid Logistic All In',
    value: '4'
  },
  {
    label: 'Unpaid Logistic',
    value: '6'
  },
  {
    label: 'Paid All',
    value: '8'
  },
  {
    label: 'Waiting Total Cost',
    value: '48'
  },
  {
    label: 'Pending',
    value: '49'
  },
  {
    label: 'Paid Logistic All In',
    value: '77'
  },
]

const defaultOrderStatus = [
  {
    label: 'Pending',
    value: '9'
  },
  {
    label: 'Processing',
    value: '10'
  },
  {
    label: 'Shipping Partially',
    value: '11'
  },
  {
    label: 'Shipping',
    value: '12'
  },
  {
    label: 'Refunded',
    value: '13'
  },
  {
    label: 'Waiting Payment',
    value: '37'
  },
  {
    label: 'Cancelled',
    value: '39'
  },
  {
    label: 'Finished',
    value: '40'
  },
  {
    label: 'Waiting Quote',
    value: '44'
  },
  {
    label: 'Expired',
    value: '45'
  },
  {
    label: 'In Warehouse Checking',
    value: '46'
  },
  {
    label: 'Ready To Ship',
    value: '47'
  },
  {
    label: 'Waiting Confirmation',
    value: '54'
  },
  {
    label: 'Confirming Payment',
    value: '55'
  },
  {
    label: 'Draft',
    value: '68'
  },
  {
    label: 'Quote Ready',
    value: '78'
  },
  {
    label: 'Finished Shipping',
    value: '79'
  },
  {
    label: 'Waiting Final Payment',
    value: '80'
  },
  {
    label: 'Waiting Goods Ready',
    value: '81'
  },
]

const defaultOrderChannel = [
  {
    label: 'Order From Channel',
    value: '0'
  },
]

const AllListOrder = () => {
  const navigate = useNavigate()
  const [orderList, setOrderList] = useState([])
  const [paramsOrder, setParamsOrder] = useState(defaultParams)
  const [totalOrder, setTotalOrder] = useState(0)
  const [loading, setLoading] = useState(true)

  const [paymentStatus, setPaymentStatus] = useState(null)
  // eslint-disable-next-line
  const [paymentStatusList, setPaymentStatusList] = useState(defaultPaymentStatus)
  const [orderStatus, setOrderStatus] = useState(null)
  // eslint-disable-next-line
  const [orderStatusList, setOrderStatusList] = useState(defaultOrderStatus)
  const [orderChannel, setOrderChannel] = useState(null)
  // eslint-disable-next-line
  const [orderChannelList, setOrderChannelList] = useState(defaultOrderChannel)

  const [modalFilterOrder, setModalFilterOrder] = useState(false)

  const dispatch = useDispatch()

  const mappingRoute = [
    {
      label: '/',
      route: null
    },
    {
      label: 'Order',
      route: null
    },
  ]

  const handleGetAllOrderList = async () => {
    setLoading(true)
    try {
      const response = await getAllOrderList(paramsOrder)

      const pickIncludedOrderPaymentStatus = response.included.statuses || []
      const pickIncludedUser = response.included.user || []
      const pickIncludedSales = response.included.sales || []
      const platforms = response.included.platform || []
      const pickStatusHistories = response.included.status_histories || []

      const takeCustomerName = (shipping) => {
        if (shipping.first_name) {
          return `${shipping.first_name !== null ? shipping.first_name : ''} ${shipping.last_name !== null ? shipping.last_name : ''}`
        } else {
          return '-'
        }
      }

      const takeUserName = (userId) => {
        const findName = pickIncludedUser[userId] || ''

        if (findName) {
          const name = findName.attributes.name
          return name
        } else {
          return ''
        }
      }

      const takeSalesName = (salesId) => {
        const findName = pickIncludedSales[salesId] || ''

        if (findName) {
          const name = findName.attributes.name
          return name
        } else {
          return ''
        }
      }

      const takePlatform = (platformId) => {
        const platform = platforms[platformId] || ''

        if (platform) {
          return {
            name: platform.attributes.name,
            label: platform.attributes.label,
            url: platform.attributes.url,
          }
        } else {
          return {
            name: '#Deleted',
            label: 'delete',
            url: '#',
          }
        }
      }

      const takeStatusHistories = (statusId) => {
        const findStatus = pickStatusHistories[statusId] || ''
        if (findStatus) {
          const data = findStatus.attributes
          return data
        } else {
          return null
        }
      }

      const getOrderAndPaymentStatus = (status, payment, id) => {
        let data = null
        status.forEach(s => {
          if(id){
            if(payment){
              const statusInclude = pickIncludedOrderPaymentStatus[s.id]
              if(statusInclude.attributes.type === 1){
                data = statusInclude.attributes.id
              }
            }else {
              const statusInclude = pickIncludedOrderPaymentStatus[s.id]
              if(statusInclude.attributes.type === 2){
                data = statusInclude.attributes.id
              }
            }
          }else if(payment){
            const statusInclude = pickIncludedOrderPaymentStatus[s.id]
            if(statusInclude.attributes.type === 1){
              data = statusInclude.attributes.name
            }
          }else {
            const statusInclude = pickIncludedOrderPaymentStatus[s.id]
            if(statusInclude.attributes.type === 2){
              data = statusInclude.attributes.name
            }
          }
        })
        return data
      }

      const getOrderAndPaymentStatusDate = (status, payment) => {
        let data = null
        status.forEach(s => {
          if(payment){
            const statusInclude = pickIncludedOrderPaymentStatus[s.id]
            if(statusInclude.attributes.type === 1){
              data = statusInclude.attributes.pivot.date
            }
          } else {
            const statusInclude = pickIncludedOrderPaymentStatus[s.id]
            if(statusInclude.attributes.type === 2){
              data = statusInclude.attributes.pivot.date
            }
          }
        })
        return data
      }

      const dataOrder = response.data
      const remapDataOrder = dataOrder.map((val) => {
        return {
          id: val.attributes.id,
          orderCode: val.attributes.order_code,
          platformId: val.attributes.platform_id,
          platform: takePlatform(val.attributes.platform_id) ,
          orderCurrency: val.attributes.currency_order,
          orderDate: val.attributes.order_date,
          customerName: takeCustomerName(val.attributes.order_infos.shipping || ''),
          orderById: val.attributes.user_id,
          createdByName: takeUserName(val.attributes.user_id),
          agentId: val.attributes.ordered_by_user_id,
          countryProducts: val.attributes.origin,
          destinationProducts: val.attributes.destination,
          shipmentFromId: val.attributes.shipment_from,
          shipmentToId: val.attributes.shipment_to,
          shipmentMethodName: shipmentMethod[val.attributes.shipment_method],
          grandTotal: val.attributes.grand_total,
          paymentStatusId: getOrderAndPaymentStatus(val.relationships.statuses, true, true),
          paymentStatus: getOrderAndPaymentStatus(val.relationships.statuses, true, false),
          paymentStatusDate: getOrderAndPaymentStatusDate(val.relationships.statuses, true),
          orderStatusId: getOrderAndPaymentStatus(val.relationships.statuses, false, true) || '',
          orderStatus: getOrderAndPaymentStatus(val.relationships.statuses, false, false),
          trackingCode: val.attributes.tracking_code,
          dropshipInfo: val.attributes.order_infos.platform,
          salesName: val.relationships.sales !== undefined ? takeSalesName(val.relationships.sales.id) : null,
          orderCategory: val.attributes.order_category,
          orderType: val.attributes.order_type,
          totalLogisticAllIn: val.attributes.total_custom_charges + val.attributes.total_logistic_charges,
          totalPaidByUser: val.attributes.been_paid,
          updatedAt: val.attributes.updated_at,
          createdAt: val.attributes.created_at,
          lastHistoryStatus: val.relationships.status_histories.length > 0 ? takeStatusHistories(val.relationships.status_histories.pop().id) : null,
          markingCode: val.attributes.marking_code,
          terms: val.attributes.terms,
          termsNote: val.attributes.terms_note,
          loadType: val.attributes.load_type,
          invoiceUrl: val.attributes.invoice_url
        }
      })

      setOrderList(remapDataOrder)

      const countOrder = response.meta.pagination.total
      setTotalOrder(countOrder)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    dispatch(updateRoute({ 'data': mappingRoute }))
    // eslint-disable-next-line
  }, [dispatch])

  useEffect(() => {
    handleGetAllOrderList()
    // eslint-disable-next-line
  }, [paramsOrder])

  useEffect(() => {
    const _statuses = paymentStatus && orderStatus
      ? `${paymentStatus}, ${orderStatus}`
      : paymentStatus || orderStatus
    setParamsOrder((oldVal) => ({ ...oldVal, 'filter[statuses.id][is]': _statuses }))
    setParamsOrder((oldVal) => ({ ...oldVal, 'filter[platform_id][not]': orderChannel }))

    // eslint-disable-next-line
    setParamsOrder((oldVal) => ({ ...oldVal, ['page[num]']: 1 }))
  }, [orderChannel, paymentStatus, orderStatus])

  const handleApplyFilter = (params) => {
    setParamsOrder((oldVal) => ({ ...oldVal, ...params }))
  }

  const handleChangePage = (val) => {
    // eslint-disable-next-line
    setParamsOrder((oldVal) => ({ ...oldVal, ['page[num]']: val }))
  }

  const renderFilterInfo = (parameter) => {
    if (
      parameter['filter[order_code][like]']
      || parameter['filter[marking_code][like]']
      || parameter['filter[order_infos][like]']
      || parameter['filter[user_id][is]']
      || parameter['filter[agent.name][like]']
      || parameter['filter[sales.name][like]']
      || parameter['filter[shipment_from][is]']
      || parameter['filter[shipment_to][is]']
      || parameter['filter[order_date][like]']
      || parameter['filter[order_date][gte]']
      || parameter['filter[order_date][lte]']
      || parameter['filter[created_at][like]']
      || parameter['filter[created_at][gte]']
      || parameter['filter[created_at][lte]']
      || parameter['filter[statuses.id][is]']
    ) {
      return (
        <Box>
          <Group gap='sm' align='center' mb={12}>
            {parameter['filter[order_code][like]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Order Number : {parameter['filter[order_code][like]']}</Badge> : ''}
            {parameter['filter[marking_code][like]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Marking Code : {parameter['filter[marking_code][like]']}</Badge> : ''}
            {parameter['filter[order_infos][like]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Customer : {parameter['filter[order_infos][like]']}</Badge> : ''}
            {parameter['filter[user_id][is]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>User : {parameter['filter[user_id][is]']}</Badge> : ''}
            {parameter['filter[agent.name][like]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Agent : {parameter['filter[agent.name][like]']}</Badge> : ''}
            {parameter['filter[sales.name][like]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Sales : {parameter['filter[sales.name][like]']}</Badge> : ''}
            {parameter['filter[shipment_from][is]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Shipment From : {parameter['filter[shipment_from][is]']}</Badge> : ''}
            {parameter['filter[shipment_to][is]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Shipment To : {parameter['filter[shipment_to][is]']}</Badge> : ''}
            {parameter['filter[order_date][like]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Order Date : {dayjs(parameter['filter[order_date][like]']).format('YYYY-MM-DD')}</Badge> : ''}
            {parameter['filter[order_date][gte]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Order Date From Date : {dayjs(parameter['filter[order_date][gte]']).format('YYYY-MM-DD')}</Badge> : ''}
            {parameter['filter[order_date][lte]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Order Date To Date : {dayjs(parameter['filter[order_date][lte]']).format('YYYY-MM-DD')}</Badge> : ''}
            {parameter['filter[created_at][like]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Created Date: {dayjs(parameter['filter[created_at][like]']).format('YYYY-MM-DD')}</Badge> : ''}
            {parameter['filter[created_at][gte]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Created Date From Date : {dayjs(parameter['filter[created_at][gte]']).format('YYYY-MM-DD')}</Badge> : ''}
            {parameter['filter[created_at][lte]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Created Date To Date : {dayjs(parameter['filter[created_at][lte]']).format('YYYY-MM-DD')}</Badge> : ''}
            {parameter['filter[statuses.id][is]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Order Status : {parameter['filter[statuses.id][is]']}</Badge> : ''}
          </Group>
          <Group align='center' gap='sm'>
            <Button size='compact-sm' fz={11} fw='500' variant="outline" onClick={() => setModalFilterOrder(true)}>Modify Filter</Button>
            <Button size='compact-sm' fz={11} fw='500' variant="outline" onClick={() => setParamsOrder(defaultParams)}>Clear Filter</Button>
          </Group>
        </Box>
      )
    }
  }

  const remapDataOrderList = (dataOrder) => {
    const remapData = dataOrder.map((val, index) => {
      return (
        <Box key={index}>
          <OrderList data={val}  type='all-order' reloadList={handleGetAllOrderList} />
        </Box>
      )
    })
    return remapData
  }

  return (
    <AuthLayout>
      <Box my={20}>
        <Box>
          <Flex justify='space-between' align="center" mb={30}>
            <Text className={classes.titleLayout}>All Order List</Text>
            <Group gap='sm' align='center'>
              <Select value={paymentStatus} placeholder="Payment Status" size='xs' searchable clearable data={paymentStatusList} onChange={(val) => setPaymentStatus(val)} />
              <Select value={orderStatus} placeholder="Order Status" size='xs' searchable clearable data={orderStatusList} onChange={(val) => setOrderStatus(val)} />
              <Select value={orderChannel} placeholder="Order Channel" size='xs' clearable data={orderChannelList} onChange={(val) => setOrderChannel(val)} />
              <Button size='xs' variant="outline" onClick={() => setModalFilterOrder(true)}>Filter</Button>
              <Button size='xs' leftSection={<IconPlus size={14} />} onClick={() => navigate('/order/add')}>Add New Order</Button>
            </Group>
          </Flex>
        </Box>
        <Box my={30}>
          {renderFilterInfo(paramsOrder)}
          <Group mb={10} gap='xs'>
            <Text fz={12}>Total Order Found: </Text>
            <Text fz={12} fw='bold'>{totalOrder} Orders </Text>
          </Group>
          {loading ? <LoadingData /> : orderList.length > 0 ? remapDataOrderList(orderList) : <NoData />}
        </Box>
        <Flex justify='end'>
          <Pagination size='sm' onChange={handleChangePage} total={Math.ceil(totalOrder / paramsOrder['page[limit]']) || 0} />
        </Flex>
      </Box>

      <Modal size='xl' opened={modalFilterOrder} onClose={() => setModalFilterOrder(false)} title="Filter Order">
        <FormFilterOrders paramsOrder={paramsOrder} applyFilter={handleApplyFilter} onClose={() => setModalFilterOrder(false)} />
      </Modal>
    </AuthLayout>
  )
}

export default AllListOrder
